import { GridFilterItem, GridFilterOperator } from '@mui/x-data-grid-pro';
import { formatTranslation } from 'intl';
import { FiltersTranslationKeys } from 'intl/keys';
import { IntlShape } from 'react-intl';
import { DocumentState } from '../../types';
import { documentStateValueGetter } from '../../valueGetters';
import { createRowValueEqualsFilterPredicate } from '../common';
import { DocumentStateFilterInput } from '../documentStateFilter';

export const getDocumentStateOperator = (
  intl: IntlShape
): GridFilterOperator => {
  const isDocumentStateFilterValue = (
    value: GridFilterItem['value']
  ): value is DocumentState => {
    return (
      value === DocumentState.published ||
      value === DocumentState.archived
    );
  };

  return {
    label: formatTranslation(intl, FiltersTranslationKeys.operatorIs),
    value: 'is',
    getApplyFilterFn: (filterItem: GridFilterItem) =>
      createRowValueEqualsFilterPredicate<
        { deleted?: boolean },
        DocumentState,
        DocumentState | null
      >(
        filterItem,
        (row) => documentStateValueGetter(null, row),
        isDocumentStateFilterValue
      ),
    InputComponent: DocumentStateFilterInput,
  };
};
